/* AdhocQueryAction.js */

"use strict";
const _ = require("lodash");
const Registrations = require("../../../../../RegistrationNamespaces");

class AdhocQueryAction {
    constructor(logger, gameEditor, modalUserFeedback, DeviceEntity, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._deviceEntity = new DeviceEntity(userSession.activeOrganization.id);
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;

        this._targetDevices = this._activeView.getSelectedDeviceIds().selectedRows;

        this.run = this.run.bind(this);
    }
    run() {
        let editorState = {
            fqn: Registrations.ADHOC_QUERY_EDITOR_VIEW_DETAILS,
        };
        let launchOpts = {
            id: _.get(this._gameEditor, "_activeOrgId", 0),
            title: "Ad Hoc Query",
            type: "AdhocQuery",
            selectedDevice: this._targetDevices,
        };
        return Promise.resolve().then(() => {
            this._gameEditor.launchAdhocQueryEditor(editorState, launchOpts);
        });
    }
}

module.exports = AdhocQueryAction;

AdhocQueryAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Device",
    "$teve.userSession",
    "gameEditor.activeView",
];

AdhocQueryAction.$displayDetails = {
    type: "Action",
    name: "AdhocQueryAction",
    icon: "devicemanager.adhoc_query_view",
    shown: true,
    title: "Ad Hoc Query",
    order: 10,
};
